import { Omit } from '@40seas/entities/common';
import { InsuranceApplication } from './insurance-application.entity';
import { BaseEntityFieldsArray } from '@40seas/models';

export class CreateInsuranceApplicationDto extends Omit(InsuranceApplication, [...BaseEntityFieldsArray]) {}
